import React from "react";
import noworkflowsvg from "./images/noworkflow.svg";
export const NoWorkflow = ({
  title = "Sorry, currently selected workflow does not exist for the asset",
}) => {
  return (
    <div className="ms-Grid" dir="ltr">
      <div className="ms-Grid-row" style={{ height: "50vh" }}>
        <div
          className="ms-Grid-col ms-sm12"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "50vh",
          }}
        >
          <img
            src={noworkflowsvg}
            alt="no workflow"
            style={{ height: "300px" }}
          />
        </div>
      </div>
      <div className="ms-Grid-row">
        <div
          className="ms-Grid-col ms-sm12"
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "20px",
          }}
        >
          <h3 style={{ color: "#F50057", fontSize: "30px" }}>{title}</h3>
        </div>
      </div>
    </div>
  );
};

